var map = {
	"./amazon.jpeg": 3529,
	"./amazon.png": 4644,
	"./btech.jpeg": 2613,
	"./btech.png": 4552,
	"./carrefour.jpeg": 3220,
	"./carrefour.png": 2835,
	"./carrefour2.jpeg": 9590,
	"./carrefour3.jpeg": 9805,
	"./jumia.jpeg": 3565,
	"./jumia.png": 5104,
	"./reward.page": 9764,
	"./reward.page.js": 9764,
	"./reward1.png": 768,
	"./reward2.png": 619,
	"./reward3.png": 9490,
	"./reward4.png": 5837,
	"./reward5.png": 4708,
	"./reward6.png": 3615,
	"./rewards.page": 7587,
	"./rewards.page.js": 7587,
	"./rewards.styles.css": 3763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1998;